import React from 'react';
import './css/Login.css';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import CustomizedSnackbars from './Message';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import logo from './logo.png';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';

function Copyright() {
  return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'© '}
        {new Date().getFullYear()}
        {' '}
        {'allstardirectories.com. All rights reserved.'}
        {' '}
      </Typography>
  );
}

class ForgetPwdViews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      asd_username: '',
      asd_password: '',
      error: {
        error_message: ''
      },
      success: {
        success_message: ''
      },
      isAuthenticate: false
    }



    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    let asd_username = this.state.asd_username;
   

    if ("" === asd_username) {
      this.setState({
        error: {
          error_message: 'Please Enter Username'
        }
      });
      return false;
    }else{
      this.setState({
        error: {
          error_message: ''
        }
      });
    }
    const loginData = { user_login: asd_username };

    const requestOptions = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }), 
      mode: 'cors',
      body: JSON.stringify({ "user_login":asd_username }),
    };




    fetch(`./wp-json/wp/v2/users/lostpassword`, requestOptions)
      .then(response => response.json())
      .then(data => {
        if (200 === data.code) {
          
          this.setState({
            success: {
              success_message: data.message
            }
          });
          this.setState({
            error: {
              error_message: ''
            }
          });
        } else {
          
          this.setState({
            error: {
              error_message: data.message
            }
          });
          this.setState({
            success: {
              success_message: ''
            }
          });
        
         
        }
      });

  }

  render() {
    const error = this.state.error.error_message;
    const success = this.state.success.success_message;
    const useStyles = makeStyles(theme => ({
      '@global': {
        body: {
          backgroundColor: theme.palette.common.white,
        },
      },
      paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
      },
      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
      },
      button: {
        margin: theme.spacing(13, 0, 2),
        background: 'orange'
      },
    }));
    const classes = useStyles;
    return (
      <div className="App login-wrap forget-password">
        <header className="App-header">
       
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
              <img src={logo} alt="logo" width="200px" height="100px" />

              <Typography component="h1" variant="h5">
                Forgot Your Password
        </Typography>
        
             <Typography component="p" margin="normal">
                To reset your password, enter your username.
                </Typography>
                {error ?
            <CustomizedSnackbars
              type="error"
              message={ReactHtmlParser(this.state.error.error_message)}
            /> : ''}

          {success ?
            <CustomizedSnackbars
              type="success"
              message={ReactHtmlParser(this.state.success.success_message)}
            /> : ''}
              <form className={classes.form} noValidate onSubmit={this.handleSubmit}>
               
                <TextField
                  
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  required
                  id="asd_username"
                  label="Required"
                  className="login_text"
                  label="Username"
                  name="asd_username"
                  value={this.state.username} onChange={this.handleChange.bind(this)}
                  //autoFocus
                />
               <Button
                  type="submit"
                  marginRight="normal"
                  variant="contained"
                  color="default"
                  className="login-btn"
                  href="/asd-login"
                >
                 Cancel
          </Button>
                <Button
                  type="submit"
                 
                  variant="contained"
                  color="primary"
                  className="login-btn"
                >
                  Reset
          </Button>

              </form>
            </div>
            <Box mt={8}>
              <Copyright />
            </Box>
          </Container>

        </header>

      </div>

    );
  }
}


export default ForgetPwdViews;
